module.exports = __webpack_public_path__ + "fonts/la-brands-400.925b340.woff";